import React from "react";

import { css } from "@emotion/react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { CSS_MQ } from "../../styles/breakpoints";
import { ContentContainer } from "../_shared-components/arrangement/Container";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { IconsAndTextsType } from "@swo/storefront";
import { IconsAndTextsItem } from "./IconsAndTextsItem";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { T } from "../T";

export const IconsAndTextsComponent: ReactTFC<IconsAndTextsType & ContentfulComponentCMSHook> = props => {
  return (
    <ContentContainer className={getComponentCMSClassname(props?.sys?.id)}>
      <div
        className={`items-${props.items.length}`}
        css={css`
          text-align: center;

          ${CSS_MQ.atLeastMd} {
            display: grid;

            &.items-1 {
              ${oneItemsGrid};
            }

            &.items-2 {
              ${twoItemsGrid};
            }

            &.items-3 {
              ${threeItemsGrid};
            }
          }

          > * {
            padding: 10px 40px;

            ${CSS_MQ.atMostSm} {
              padding: 10px 5px;
            }
          }
        `}
      >
        {props.items.slice(0, 3).map((item, idx) => (
          <IconsAndTextsItem
            key={`${JSON.stringify(item.headline)}-${idx}`}
            headline={<T>{item.headline}</T>}
            icon={{
              title: item.icon.description || item.icon.title || undefined,
              url: item.icon.url,
            }}
            text={item.text}
            ctaButton={item.ctaButton}
          />
        ))}
      </div>
    </ContentContainer>
  );
};
const threeItemsGrid = css`
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-content: center;
`;

const twoItemsGrid = css`
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: center;

  width: calc(100% * 2 / 3);
  margin-left: auto;
  margin-right: auto;
`;

const oneItemsGrid = css`
  grid-template-columns: repeat(1, minmax(0, 1fr));
  justify-content: center;

  width: calc(100% * 1 / 3);
  margin-left: auto;
  margin-right: auto;
`;
